import { Component, Host, h, Prop, Element } from '@stencil/core';
import cn from 'classnames';
import { uiStore } from '../../../core/stores';
import { Modal } from '../../../core/stores/ConfigStore';
import { getCssColor } from '../../../utils/helper';
import { isCurrentRtlLang } from '../../../utils/i18n';


const alertDialogList = ['hcl-sdk-exit-link-popup']
@Component({
  tag: 'hcl-sdk-modal',
  styleUrl: 'hcl-sdk-modal.scss',
  shadow: false,
})
export class HclSdkModal {
  @Prop() modal?: Modal;
  @Element() el: HTMLElement;
  @Prop() closeModal?: () => void;
  onClose = () => {
    this.closeModal?.();
  };

  componentDidLoad() {
    focusFirstElement(this.el)
  }

  disconnectedCallback() {
    if (this.modal?.focusOnCloseElement) {
      this.modal?.focusOnCloseElement?.focus?.()
    }
    if (this.modal?.focusOnCloseSelector) {
      (document.querySelector(this.modal?.focusOnCloseSelector) as HTMLElement)?.focus?.()
    }
  }

  render() {
    if (!this.modal) {
      return null;
    }
    const modalClass = cn('modal-class', this.modal.className);
    const isAlertDialog = alertDialogList.includes(this.modal.component)
    return (
      <Host class={`size-${uiStore.state.breakpoint.screenSize}`} id={`dialog-${this.modal.component}`} role={isAlertDialog ? "alertdialog" : "dialog"} aria-labelledby={`dialog-title-${this.modal.component}`} aria-describedby={`dialog-description-${this.modal.component}`}>
        <div class={cn('modal-container')} onClick={this.modal.closeOnClickOutside ? () => {this.onClose()} : undefined}></div>
        <div class={modalClass}>
            <div class="modal-title">
              {this.modal.title && <p id={`dialog-title-${this.modal.component}`} class={cn("title", {rtl: isCurrentRtlLang()})}>{this.modal.title}</p>}
              {!this.modal.hideDefaultClose && (
              <hcl-sdk-icon
                name="remove"
                tabIndex={0}
                class="modal-close"
                role="button"
                aria-label="Close"
                onKeyUp={e => {
                  if (e.key == 'Enter' || e.key == ' ') {
                    this.onClose();
                  }
                }}
                onClick={this.onClose}
                color={getCssColor('--hcl-color-grey_dark')}
                width={20}
                height={20}
              />
            )}
            </div>
            <div class="modal-content">
              <this.modal.component onClose={this.onClose} {...(this.modal.componentProps && { ...this.modal.componentProps })} />
            </div>
          </div>
      </Host>
    );
  }
}

function focusFirstElement(dialog: HTMLElement) {
  const focusableSelectors = [
    'a[href]',
    'area[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'iframe',
    'object',
    'embed',
    '[contenteditable]',
    '[tabindex]:not([tabindex="-1"]):not([aria-label="Close"])'
  ];

  const focusableElements = dialog.querySelectorAll(focusableSelectors.join(','));
  
  if (focusableElements.length > 0) {
    (focusableElements[0] as HTMLElement).focus?.();
  }
}
